import { fetchOnlinePay, getOnlinePay } from "utils/api";

export const queryEmployee = async (params) => {
  return await getOnlinePay("/employee/list", {
    sort: "id,desc",
    ...params,
  });
};

export const updateStatus = async (params) => {
  return await fetchOnlinePay("/action", {
    action: "employeeUpdate",
    ...params,
  });
};

export const changePassword = async (params) => {
  return await fetchOnlinePay("/action", {
    action: "employeeChangePass",
    ...params,
  });
};
